import ExportCommentsWidget from './ExportCommentsWidget';
export default ExportCommentsWidget;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/components/ExportCommentsWidget/index.js